import script from "./DashboardLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardLayout.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardLayout.vue?vue&type=style&index=0&id=d428ee7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d428ee7a"]])

export default __exports__